import React from 'react';
import { DayCell } from '../DayCell';
import { CalendarViewProps } from '../../types/planning.types';
import { formatDateHeader } from '../../utils/dateFormatters';
import { getExpertisesForDate } from '../../utils/calendarHelpers';
import './CalendarView.styles.css';

export const CalendarView: React.FC<CalendarViewProps> = ({
  weekDates,
  expertises,
  onExpertiseClick
}) => {
  // For mobile, render each day as a complete unit (header + content)
  const renderMobileView = () => {
    return (
      <div className="calendar-mobile">
        {weekDates.map((date, index) => {
          const headerInfo = formatDateHeader(date);
          const dayExpertises = getExpertisesForDate(date, expertises);
          
          return (
            <div key={`day-${index}`} className="calendar-mobile__day">
              <div 
                className={`calendar-header ${headerInfo.isToday ? 'calendar-header--today' : ''} ${headerInfo.isPast ? 'calendar-header--past' : ''}`}
              >
                <div className="calendar-header__day">{headerInfo.day}</div>
                <div className="calendar-header__date">{headerInfo.date}</div>
                <div className="calendar-header__month">{headerInfo.month}</div>
              </div>
              <DayCell
                date={date}
                expertises={dayExpertises}
                isToday={headerInfo.isToday}
                isPast={headerInfo.isPast}
                onExpertiseClick={onExpertiseClick}
              />
            </div>
          );
        })}
      </div>
    );
  };

  // Desktop view with grid
  const renderDesktopView = () => {
    return (
      <div className="calendar-grid">
        {/* Day headers */}
        {weekDates.map((date, index) => {
          const headerInfo = formatDateHeader(date);
          return (
            <div 
              key={`header-${index}`} 
              className={`calendar-header ${headerInfo.isToday ? 'calendar-header--today' : ''} ${headerInfo.isPast ? 'calendar-header--past' : ''}`}
            >
              <div className="calendar-header__day">{headerInfo.day}</div>
              <div className="calendar-header__date">{headerInfo.date}</div>
              <div className="calendar-header__month">{headerInfo.month}</div>
            </div>
          );
        })}
        
        {/* Day cells with expertises */}
        {weekDates.map((date, index) => {
          const headerInfo = formatDateHeader(date);
          const dayExpertises = getExpertisesForDate(date, expertises);
          
          return (
            <DayCell
              key={`cell-${index}`}
              date={date}
              expertises={dayExpertises}
              isToday={headerInfo.isToday}
              isPast={headerInfo.isPast}
              onExpertiseClick={onExpertiseClick}
            />
          );
        })}
      </div>
    );
  };

  return (
    <div className="calendar-container">
      <div className="calendar-desktop">
        {renderDesktopView()}
      </div>
      <div className="calendar-mobile-wrapper">
        {renderMobileView()}
      </div>
    </div>
  );
};